// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getBottomSuggestionPadding(bottom?: number): number {
    return 6;
}

export default getBottomSuggestionPadding;
